// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__1fyeL","noUnderlineOnHover":"Link_noUnderlineOnHover__38_ty"};